import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface MarqueeProps extends ComponentPropsWithoutRef<'div'> {
  /**
   * Optional CSS class name to apply custom styles
   */
  className?: string;
  /**
   * Whether to reverse the animation direction
   * @default false
   */
  reverse?: boolean;
  /**
   * Whether to pause the animation on hover
   * @default false
   */
  pauseOnHover?: boolean;
  /**
   * Content to be displayed in the marquee
   */
  children: React.ReactNode;
  /**
   * Whether to animate vertically instead of horizontally
   * @default false
   */
  vertical?: boolean;
  /**
   * Number of times to repeat the content
   * @default 4
   */
  repeat?: number;
}

export function Marquee({
  className,
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={twMerge(
        'group flex overflow-hidden p-2 [--duration:40s] [--gap:1rem] [gap:var(--gap)]',
        vertical ? 'flex-col' : 'flex-row',
        className
      )}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={twMerge(
              'flex shrink-0 justify-around [gap:var(--gap)]',
              !vertical ? 'animate-marquee flex-row' : '',
              vertical ? 'animate-marquee-vertical flex-col' : '',
              pauseOnHover ? 'group-hover:[animation-play-state:paused]' : '',
              reverse ? '[animation-direction:reverse]' : ''
            )}
          >
            {children}
          </div>
        ))}
    </div>
  );
}
